import { BaseModel, BoardResolutionMode, CrsTaxResidenceModel, YesNoToBoolean } from '@core/data-access';
import { Default } from '@core/util';
import { Exclude, Expose, Type } from 'class-transformer';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { PersonnelAddressModel } from './personnel-address.model';
import { UsPersonModel } from './us-person.model';

export class BusinessEntityModel extends BaseModel {
  @Expose()
  registeredAddress!: string;

  @Expose()
  officeContactNumber!: string;

  @Expose()
  officeContactAreaCode!: string;

  @Expose() businessActivity!: string;

  @Expose() businessClassification!: string;

  @Expose() email!: string;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  gstRegistered!: boolean;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  propertyCorporation!: boolean;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  companyProfitable!: boolean;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  usCorporation!: boolean;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  participateIndirectly!: boolean;

  @Expose() tin!: string;

  @Expose()
  @Type(() => Boolean)
  @YesNoToBoolean()
  usIndicia!: boolean;

  @Expose()
  @Type(() => PersonnelAddressModel)
  address!: PersonnelAddressModel;
}

@Exclude()
export class BoardResolutionApprovingPersonsModel extends BaseModel {
  @Expose() @Default(null) personnelUuid!: string | null;
}

@Exclude()
export class BoardResolutionModel extends BaseModel {
  @Expose() mode!: BoardResolutionMode | null;

  @Expose() @Type(() => Boolean) @Default(null) isReviewedBoardResolution!: boolean | null;

  @Expose() @Default([]) approvingPersons!: BoardResolutionApprovingPersonsModel[];

  @Expose({ toClassOnly: true })
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  attachment!: UploadFileControl;
}

@Exclude()
export class BoardResolutionConfirmModel extends BoardResolutionModel {}

export class CommonReportingForEntityModel extends BaseModel {
  @Expose({ toClassOnly: true }) doNotHaveOne!: boolean;

  @Expose() typeOfFinancial!: string;

  @Expose() taxResidences!: CrsTaxResidenceModel[];
}

@Exclude()
export class BusinessDeclarationUsPerson extends BaseModel {
  @Expose()
  @Default([])
  @Type(() => UsPersonModel)
  listOfShareholders!: UsPersonModel[];
}
